import Footers from './footer/index'
import FooterStyle from './footer/style'
export { Footers, FooterStyle}



// WEBPACK FOOTER //
// ./src/view/pc/footerPage/components/plugins/index.js